import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService, ModelData, ModalSize, QueryParameter, ModalService, FormType } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { User } from './user';
import { UserNapomenaComponent } from '../user-napomena/user-napomena.component';

@Component({
  selector: 'yt-user-tab-update',
  templateUrl: './user-tab-update.component.html'
})
export class UserTabUpdateComponent extends BaseTabsUpdateComponent<User> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<User>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  userID: number;

  ngOnInit() {
    super.ngOnInit();

    this.baseUpdateComponent.IDProcessed.subscribe((value) => {
      if (value && this.baseUpdateComponent.Item.ID > 0)
      this.userID = this.baseUpdateComponent.Item.ID
    });
  }

  UcitajPoljeZaNapomenu(){
    let modelData = new ModelData(null);
    modelData.ModalSize = ModalSize.Lg;
    modelData.UpdateComponent = UserNapomenaComponent;
    

    let userIDParameter = new QueryParameter('UserID', this.userID);



    if(modelData){
      this.modalService.ShowModal(0, modelData, null, true, [
        userIDParameter
      ])
      .result.then( result => {
        //this.fakBaseUpdate.SetPoljaZaVelikeLance = result;
      },
      () =>{})
    }
  }

}
